import { dialog } from "../../../nq-component";
import BaseFormPresenter from "../../../base/BaseFormPresenter";
import DialogWarning from "../components/Dialog/DialogWarning";
import DialogSuccess from "../components/Dialog/DialogSuccess";

class InterviewFormPagePresenter extends BaseFormPresenter {
  constructor(
    view,
    upsertUseCase,
    getObjectUseCase,
    findObjectUseCase,
    deleteObjectUseCase,
    auditUseCase
  ) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.auditUseCase = auditUseCase;
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async handleSubmit(formState, object, totalPoints) {
    const user = this.view.getCurrentUser();
    const auditAction = !object?.interviewForm ? "CREATE" : "UPDATE";
    const auditDesc = !object?.interviewForm
      ? "Interviewed the Applicant"
      : "Updated the Interview Form";

    try {
      this.view.showLoading();
      const applicantsName = `${object?.firstName} ${object?.lastName}`;

      const report = {
        recruiter: { id: object?.recruiter?.id },
        applicant: applicantsName,
        status: "interviewed",
      };

      const datas = {
        ...formState,
        totalRating: totalPoints,
        applicantFirstName: object?.firstName,
        applicantMiddleName: object?.middleName,
        applicantLastName: object?.lastName,
      };

      const applicantData = {
        ...object,
        applicant: { id: object?.applicant?.id },
        recruiter: { id: object?.recruiter?.id },
        image2: formState?.file,
      };

      const filteredForm = Object.fromEntries(
        Object.entries(formState).filter(
          ([key]) => key !== "comments" && key !== "recommendation"
        )
      );

      const isFormValid = Object.values(filteredForm).every(
        (value) => value !== "" && value !== null && value !== undefined
      );

      if (!isFormValid) {
        this.view.hideLoading();
        dialog.fire({
          html: <DialogWarning message="Please fill out all fields" />,
          footer: false,
        });
        return;
      }

      await this.upsertUseCase.execute("recruiters_report", report);

      const interviewForm = await this.upsertUseCase.execute(
        "interview_form",
        datas
      );

      applicantData.interviewForm = { id: interviewForm?.id };

      await this.upsertUseCase.execute("reprocess_applicants", applicantData);

      const auditObject = {
        user: { id: user?.id },
        action: auditAction,
        application_id: applicantData?.id,
        module: "Interview Form",
        description: auditDesc,
      };

      await this.auditUseCase.execute(auditObject);

      this.view.hideLoading();
      dialog.fire({
        html: <DialogSuccess message="Successfully Saved" />,
        footer: false,
      });
    } catch (error) {
      this.view.hideLoading();
      console.error("Error while submitting applicant data:", error);
      dialog.fire({
        html: (
          <DialogWarning message="Something went wrong. Please try again." />
        ),
        footer: false,
      });
    }
  }
}

export default InterviewFormPagePresenter;
